// Staff tapped Cancel on an in-flight Tyro charge.
// Stay on the payment screen until Tyro says approved or failed.
// A staff-initiated fail goes back to the cart — not Retry / Close.

function staffCancelNextAction({ staffCancel = false, approved = false, failed = false } = {}) {
  if (approved) return 'complete_sale';
  if (failed) return staffCancel ? 'return_to_cart' : 'show_failed';
  return staffCancel ? 'keep_cancelling' : 'keep_waiting';
}

module.exports = { staffCancelNextAction };
